// extracted by mini-css-extract-plugin
module.exports = {"sigPad":"styles_sigPad__1m6EA"};